export function seriesVideoSlider() {
    let initializedClassName = "initialized";

    $(".series-video-slider").each(function () {
        let slider = $(this);

        if (!slider.hasClass(initializedClassName)) {
            let items = slider.find(".series-item");

            if (items.length > 1) {
                slider
                    .addClass(initializedClassName)
                    .slick({
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        focusOnSelect: true,
                        dots: true,
                        arrows: false,
                        responsive: [
                            {
                                breakpoint: 568,
                                settings: {
                                    slidesToShow: 2,
                                    arrows: true,
                                    dots: false,
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3,
                                    arrows: true,
                                    dots: false,
                                }
                            },
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4,
                                    arrows: true,
                                    dots: false,
                                }
                            }
                        ]
                    });
            }
        }
    });
}








// WEBPACK FOOTER //
// ./assets/js/modules/seriesVideoSlider.js